(function (angular) {
	'use strict';

	angular
		.module('iraModule')
		.controller('IraSignupCitizenship', [
			'$window',
			'globalConfig',
			'mixpanelFactory',
			'UserFactory',
			IraSignupCitizenshipFunction
		]);

	function IraSignupCitizenshipFunction(
		$window,
		globalConfig,
		mixpanelFactory,
		UserFactory) {

		var citizenship = this;

		citizenship.$onInit = function () {
			mixpanelFactory.track('Signup Select Citizenship IRA Viewed');
			citizenship.countries = globalConfig.countries;

			var USIndex = 0;
			
			angular.forEach(citizenship.countries, function(country, index){
				if (country.code === 'US') {
					USIndex = index;
				}
			});
			
			citizenship.citizenshipCountryCode = citizenship.countries[USIndex];
			citizenship.residenceCountryCode = citizenship.countries[USIndex];
		};

		function buildRequest () {

			var requestBody = {
				"citizenshipCountryCode": citizenship.citizenshipCountryCode.code,
				"residenceCountryCode": citizenship.residenceCountryCode.code
			};

			return requestBody;
		}


		function submitForm () {
			$window.document.getElementById('citizenshipForm').submit();
		}

		citizenship.submit = function () {
			UserFactory.saveCitizenship(buildRequest(), citizenship.citizenshipForm)
			.then(function(response) {
				submitForm();
			})
			.catch(function(response) {
				citizenship.formSubmitted = false;
			});
		};
	}
})(window.angular);